module.exports = __webpack_public_path__ + "img/paper-plane.5f0d2a17.svg";